// Accounting routes: ledger, payments, bank, VAT, ZATCA, periods, budgets, assets
import Accounts from '../pages/Accounts';
import Journal from '../pages/Journal';
import CancellationsLog from '../pages/CancellationsLog';
import DataHealthCenter from '../pages/DataHealthCenter';
import Payments from '../pages/Payments';
import Bank from '../pages/Bank';
import BankAdjustments from '../pages/BankAdjustments';
import PettyCash from '../pages/PettyCash';
import Assets from '../pages/Assets';
import Periods from '../pages/Periods';
import Budgets from '../pages/Budgets';
import Expenses from '../pages/Expenses';
import ExpensesReport from '../pages/ExpensesReport';
import VATReturns from '../pages/VATReturns';
import VATClaimManagement from '../pages/VATClaimManagement';
import BillsCenter from '../pages/BillsCenter';
import ExpenseCategories from '../pages/ExpenseCategories';
import GovernmentServices from '../pages/GovernmentServices';
import GovUtilityPayments from '../pages/GovUtilityPayments';
import FinancialOperationsCenter from '../pages/FinancialOperationsCenter';
import BankReconciliation from '../pages/BankReconciliation';
import BankRules from '../pages/BankRules';
import BankTemplateWizard from '../pages/BankTemplateWizard';
import StatementRegistry from '../pages/StatementRegistry';
import BankImportManager from '../pages/BankImportManager';
import MatchingIntelligence from '../pages/MatchingIntelligence';
import DocumentHub from '../pages/DocumentHub';
import BillReviewConsole from '../pages/BillReviewConsole';
import PaymentQueue from '../pages/PaymentQueue';
import PaymentRunDetail, { PaymentRunsList } from '../pages/PaymentRuns';
import FinancialTimelines from '../pages/FinancialTimelines';
import FinancialTimelinePage from '../pages/FinancialTimeline';
import ZATCA from '../pages/ZATCA';
import ZATCACompliance from '../pages/ZATCACompliance';
import AccountingReports from '../pages/AccountingReports';
import CostCenters from '../pages/CostCenters';
import MonthEndClosing from '../pages/MonthEndClosing';
import OverheadReport from '../pages/OverheadReport';
import CFODashboard from '../pages/CFODashboard';
import CfoEmailPreview from '../pages/CfoEmailPreview';
import YearEnd from '../pages/YearEnd';
import CashGLMismatchConsole from '../pages/CashGLMismatchConsole';
import CFOPnlPage from '../pages/CFOPnlPage';
import CFOPack from '../pages/CFOPack';
import CreditControl from '../pages/CreditControl';
import FinancialTruthDashboard from '../pages/FinancialTruthDashboard';
import ReconciliationCenter from '../pages/ReconciliationCenter';
import FinancialRepairCenter from '../pages/FinancialRepairCenter';
import AdminFinancialRepair from '../pages/AdminFinancialRepair';
import AdminCoAClassification from '../pages/AdminCoAClassification';
import AdminRecordsMaintenance from '../pages/AdminRecordsMaintenance';
import DataQualityCenter from '../pages/DataQualityCenter';
import SystemDiagnosticCenter from '../pages/SystemDiagnosticCenter';
import Reports from '../pages/Reports';
import InstantReports from '../pages/InstantReports';
import CashExpensesLedger from '../pages/CashExpensesLedger';
import Approvals from '../pages/Approvals';

const accountingRoutes = [
  { path: '/accounts', Component: Accounts },
  { path: '/journal', Component: Journal, withUser: true },
  { path: '/cancellations-log', Component: CancellationsLog },
  { path: '/data-health', Component: DataHealthCenter },
  { path: '/payments', Component: Payments, withUser: true },
  { path: '/bank', Component: Bank, withUser: true },
  { path: '/bank/adjustments', Component: BankAdjustments, withUser: true },
  { path: '/petty-cash', Component: PettyCash },
  { path: '/assets', Component: Assets },
  { path: '/periods', Component: Periods, withUser: true },
  { path: '/budgets', Component: Budgets },
  { path: '/expenses', Component: Expenses },
  { path: '/expenses-report', Component: ExpensesReport },
  { path: '/gov-utility-payments', Component: GovUtilityPayments },
  { path: '/vat-return', Component: VATReturns },
  { path: '/vat-returns', Component: VATReturns },
  { path: '/vat-claims', Component: VATClaimManagement, withUser: true },
  { path: '/bills-center', Component: BillsCenter, withUser: true },
  { path: '/expense-categories', Component: ExpenseCategories, withUser: true },
  { path: '/government-services', Component: GovernmentServices, withUser: true },
  { path: '/financial-ops', Component: FinancialOperationsCenter, withUser: true },
  { path: '/bank-reconciliation', Component: BankReconciliation, withUser: true },
  { path: '/bank-rules', Component: BankRules, withUser: true },
  { path: '/bank-template-wizard', Component: BankTemplateWizard, withUser: true },
  { path: '/bank-statements-registry', Component: StatementRegistry, withUser: true },
  { path: '/bank-import-manager', Component: BankImportManager, withUser: true },
  { path: '/matching-intelligence', Component: MatchingIntelligence, withUser: true },
  { path: '/document-hub', Component: DocumentHub, withUser: true },
  { path: '/bill-review/:billId', Component: BillReviewConsole, withUser: true },
  { path: '/payment-queue', Component: PaymentQueue, withUser: true },
  { path: '/payment-runs', Component: PaymentRunsList, withUser: true },
  { path: '/payment-runs/:runId', Component: PaymentRunDetail, withUser: true },
  { path: '/financial-timelines', Component: FinancialTimelines, withUser: true },
  { path: '/financial-timeline/:flId', Component: FinancialTimelinePage, withUser: true },
  { path: '/zatca', Component: ZATCACompliance },
  { path: '/zatca/setup', Component: ZATCA },
  { path: '/zatca/compliance', Component: ZATCACompliance },
  { path: '/accounting-reports', Component: AccountingReports, withUser: true },
  { path: '/cost-centers', Component: CostCenters, withUser: true },
  { path: '/month-end', Component: MonthEndClosing, withUser: true },
  { path: '/overhead-report', Component: OverheadReport },
  { path: '/cfo-dashboard',   Component: CFODashboard },
  { path: '/cfo-email-preview', Component: CfoEmailPreview },
  { path: '/reconciliation-center', Component: ReconciliationCenter },  { path: '/financial-repair-center', Component: FinancialRepairCenter },
  { path: '/admin/financial-repair', Component: AdminFinancialRepair, withUser: true },
  { path: '/admin/coa-classification', Component: AdminCoAClassification, withUser: true },
  { path: '/admin/records-maintenance', Component: AdminRecordsMaintenance, withUser: true },
  { path: '/data-quality-center', Component: DataQualityCenter },
  { path: '/system-diagnostic', Component: SystemDiagnosticCenter },
  { path: '/year-end', Component: YearEnd, withUser: true },
  { path: '/cfo-pnl', Component: CFOPnlPage },
  { path: '/cfo-pack', Component: CFOPack },
  { path: '/credit-control', Component: CreditControl },
  { path: '/dvl-financial-dashboard', Component: FinancialTruthDashboard },
  { path: '/reports', Component: Reports },
  { path: '/instant-reports', Component: InstantReports, withUser: true },
  { path: '/cash-expenses-ledger', Component: CashExpensesLedger },
  { path: '/diagnostics/cash-gl-mismatch', Component: CashGLMismatchConsole, withUser: true },
  { path: '/approvals', Component: Approvals },
];

export default accountingRoutes;
